import Component from "@base/js/component";

export default class SeriesLanding extends Component {
  // Defines the element selector which will initialize this component
  static selector = ".series-landing";

  // Defines children that needs to be queried as part of this component
  static children = {
    // body: ".series-landing__body" // Queries a single element
    // items: [".series-landing__items"] // Queries a an array of elements
  };

  // Defines sub components that needs to be queried as part of this component
  static members = {
    // subComponent: ComponentClass, // Maps as a single subcomponent instance
    // subComponents: [ComponentClass], // Maps as an array of subcomponent instances
  };

  // constructor() {
  //   super();
  // }

  // Will be called upon component instantiation
  afterInit() {
    // console.log(`Component initialized`, this.element);
  }
}

// Remove this line if this component is not intended
// to initialize on DOM load.
SeriesLanding.init();
